import { ContactsWorkspace } from "@/features/contacts";

export default function ContactsPage() {
  return <ContactsWorkspace />;
}
